<div *ngIf="!!chat" class="chat-header">
  <!-- TODO: Обсудить с бэком возможность добавления photoId -->
  <app-photo
    class="chat-header__avatar"
    [size]="'m'"
    [rounded]="true"
    [type]="'chat'"
    [photoSrc]="chat.avatarSrc"
    [text]="chat.chatName"
  ></app-photo>

  <div class="chat-header__info">
    <div class="chat-header__title text_size-m text_truncate">{{ chat.chatName }}</div>
    <div *ngIf="chat.chatDescription" class="chat-header__description text_size-s text_truncate">
      {{ chat.chatDescription }}
    </div>
  </div>

  <div class="chat-header__actions">
    <button
      *ngIf="detailsButtonVisible"
      tuiIconButton
      type="button"
      appearance="icon"
      size="s"
      (click)="onClickDetailsButton()"
    >
      <app-icon [ngClass]="visibleDetails ? 'active' : ''" src="panel-right"></app-icon>
    </button>

    <app-actions [mode]="'menu'" [items]="actionMenuItems">
      <button tuiIconButton type="button" appearance="icon" size="s">
        <app-icon src="ellipsis-vertical"></app-icon>
      </button>
    </app-actions>
  </div>
</div>
